if (!customElements.get('product-description-toggle')) {
  customElements.define(
    'product-description-toggle',
    class ProductDescriptionToggle extends HTMLElement {
      connectedCallback() {
        this.description = this.querySelector('[data-product-description]');
        this.button = this.querySelector('[data-product-description-toggle]');
        if (!this.description || !this.button) return;

        this.onResize = this.onResize.bind(this);

        this.button.addEventListener('click', () => this.toggle());
        window.addEventListener('resize', this.onResize);

        this.updateButtonVisibility();

        // Il testo può ridisporsi quando i webfont sono pronti
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.updateButtonVisibility());
        }
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
      }

      get expanded() {
        return this.classList.contains('is-expanded');
      }

      toggle() {
        const expanded = !this.expanded;
        this.classList.toggle('is-expanded', expanded);
        this.button.setAttribute('aria-expanded', expanded.toString());
      }

      onResize() {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => this.updateButtonVisibility(), 150);
      }

      // Il bottone serve solo se il testo non entra tutto nella riga singola
      updateButtonVisibility() {
        if (this.expanded) return;
        this.button.hidden = this.description.scrollHeight <= this.description.clientHeight + 1;
      }
    }
  );
}
